import {HttpEvent, HttpInterceptorFn} from '@angular/common/http';
import {retry, timer} from "rxjs";

export const retryGetInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.method !== 'GET') {
    return next(req);
  }

  return next(req)
    .pipe(
      retry({
        count: 3,
        delay: (error, retryCount) => timer(500 * retryCount)
      }),
    );
};
